<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-left">
        <span class="footer-text">{{ versionText }}</span>
      </div>
      <div class="footer-right">
        <span class="footer-text">Powered by Vasion Automate</span>
      </div>
    </div>
  </footer>
</template>

<script>
import { getVersionText } from '@/utils/version.js'

export default {
  name: 'Footer',
  computed: {
    versionText() {
      return getVersionText()
    },
  },
}
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  padding: 0px 5px;
  z-index: 1000;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 10px 20px;
}

.footer-left,
.footer-right {
  flex: 1;
}

.footer-left {
  text-align: left;
}

.footer-right {
  text-align: right;
}

.footer-text {
  color: var(--primary-color);
  font-size: 14px;
  font-weight: 500;
}
</style>
